
import { Box } from "@mui/system";
import RecentTable from "./RecentTable/RecentTable";


const Recent = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
        <RecentTable/>
      </Box>
    </>
  );
};

export default Recent;
